import { z } from 'zod';

export const contactDataForTableSchema = z.object({
  id: z.string(),
  phoneNumber: z.string(),
  email: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  lastCommunicationDate: z.number().nullable(),
  hasSignedContracts: z.boolean(),
  hasPayments: z.boolean(),
  salesRep: z.string().nullable(),
  languages: z.array(z.string()),
});

export const contactTableDataSchema = z.object({
  contacts: z.array(contactDataForTableSchema),
  total: z.number(),
});

export type ContactTableData = z.infer<typeof contactTableDataSchema>;

export type ContactDataForTable = z.infer<typeof contactDataForTableSchema>;
